import ThreadIcon from "../Images/AppIcons/thread.svg";
import KnowledgeIcon from "../Images/AppIcons/cmk.svg";
import ExeIcon from "../Images/AppIcons/exe.svg";
import ProjectManagerIcon from "../Images/AppIcons/pm.svg";
import CoreIcon from "../Images/AppIcons/core.svg";
import BuilderIcon from "../Images/AppIcons/builder.svg";
import { Icon } from "../../Common/Types/Icon";

interface IAppIconService {
  getIconPathForApp(appRolePrefix: string): string;
  getIconForApp(appRolePrefix: string): Icon;
}

class AppIconService implements IAppIconService {
  getIconPathForApp(appRolePrefix: string): string {
    switch (appRolePrefix) {
      case "IM":
        return ThreadIcon;
      case "PM_":
        return ProjectManagerIcon;
      case "CMK":
        return KnowledgeIcon;
      case "EXE":
        return ExeIcon;
      case "THV2":
        return ThreadIcon;
      case "WIKI":
        return KnowledgeIcon;
      case "CMB":
        return BuilderIcon;
      case "CMBL":
        return BuilderIcon;
      default:
        return CoreIcon;
    }
  }

  getIconForApp(appRolePrefix: string): Icon {
    switch (appRolePrefix) {
      case "IM":
        return {
          appName: "cm_Products",
          assetName: "cmThread"
        };
      // case "PM_":
      //   return ProjectManagerIcon;
      case "CMK":
        return {
          appName: "cm_Products",
          assetName: "cmKnowledge"
        };
      case "EXE":
        return {
          appName: "cm_Products",
          assetName: "cmExe"
        };
      case "THV2":
        return {
          appName: "cm_Products",
          assetName: "cmThread"
        };
      // case "WIKI":
      //   return KnowledgeIcon;
      case "CMB":
        return {
          appName: "cm_Products",
          assetName: "cmBuilder"
        };
      case "CMBL":
        return {
          appName: "cm_Products",
          assetName: "cmBuilder"
        };
      default:
        return {
          appName: "cm_Products",
          assetName: "cmCore"
        };
    }
  }
}

export const appIconService: AppIconService = new AppIconService();
